import React, { useEffect, useState, lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import Select from "react-select";
import PoRevisionPrintModal from "./PoRevisionPrintModal";
import PoServices from "../../../services/PoServices";
import ReceivedOrderModal from './ReceivedOrderModal';
import * as XLSX from "xlsx";
import Pagination from "../Pagenation/Pagenation";
import Loader from "../Loader/loader";
const preloadRateChangeModal = () =>
  import("./RateChangeRequestModal");
const RateChangeRequestModal = lazy(() =>
  import("./RateChangeRequestModal")
);



const POPrint = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [sort, setSort] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const [gridInsideModal2, setGridInsideModal2] = useState(false);
  const [selectedItem2, setSelectedItem2] = useState(null);
  const [activePage, setActivePage] = useState(0);
  const [test, setTest] = useState(0);
  const [loading, setLoading] = useState(true);
  const [sortField, setSortField] = useState(null); // "createdAt" | "approvedDate"
  const [sortOrder, setSortOrder] = useState("asc"); // "asc" | "desc"
  const [rateChangeModalOpen, setRateChangeModalOpen] =
    useState(false);
  const [printLoadingId, setPrintLoadingId] =
    useState("");
  const [selectedRateChangePO, setSelectedRateChangePO] =
    useState(null);

  let userRole = "";

  try {
    const userDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}"
    );

    userRole =
      userDetails?.data?.user?.role || "";

  } catch (error) {
    userRole = "";
  }


  const options = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ];

  useEffect(() => {
    const fetchPurchaseOrders = async () => {
      try {
        setLoading(true); // Start loader

        // ✅ Fetch only 'Generated' purchase orders
        const res = await PoServices.AllPOByStatus("Confirmed-Generated");
        console.log("POprint", res?.data)
        const poList = res?.data || [];
        setPurchaseOrders(poList);
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Failed to fetch purchase orders", "error");
      } finally {
        setLoading(false); // Stop loader
      }
    };

    fetchPurchaseOrders();
  }, [test]); // Optional: use dependency if needed


  useEffect(() => {
    setActivePage(0);
  }, [searchTerm, sort]);



  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const filteredSearch = [...purchaseOrders]
    .filter(po => {
      const requisitionNumber =
        po?.requisitionNo?.requisitionNo?.toString() || "";

      const poNumber =
        po?.poNumber?.toString() || "";

      const supplierName =
        po?.items?.[0]?.supplier?.name?.toString().toLowerCase() || "";

      const createdBy =
        po?.createdBy?.name?.toString().toLowerCase() || "";

      const storeLocation =
        po?.requisitionNo?.store?.name?.toString().toLowerCase() || "";

      const search = searchTerm.toLowerCase();

      // ✅ SEARCH ALL PART NOS
      const partNoMatch = po?.items?.some(item =>
        item?.partNo?.toString().toLowerCase().includes(search)
      );

      // ✅ SEARCH ALL DESCRIPTIONS
      const descriptionMatch = po?.items?.some(item =>
        item?.description?.toString().toLowerCase().includes(search)
      );

      return (
        requisitionNumber.includes(search) ||
        poNumber.includes(search) ||
        supplierName.includes(search) ||
        createdBy.includes(search) ||
        storeLocation.includes(search) ||
        partNoMatch ||
        descriptionMatch
      );
    })
    .sort((a, b) => {
      if (!sortField) return 0;

      let valueA = 0;
      let valueB = 0;

      if (sortField === "createdAt") {
        valueA = new Date(a.createdAt).getTime();
        valueB = new Date(b.createdAt).getTime();
      }

      if (sortField === "approvedDate") {
        valueA = a?.latestApprovedDate
          ? new Date(a.latestApprovedDate).getTime()
          : 0;

        valueB = b?.latestApprovedDate
          ? new Date(b.latestApprovedDate).getTime()
          : 0;
      }

      return sortOrder === "asc"
        ? valueA - valueB
        : valueB - valueA;
    });


  const pagination = Math.ceil(filteredSearch.length / sort);

  const onClick = (i) => {
    setActivePage(i);
  };

  // ==========================================
  // PRINT PO WITH REVISION HISTORY
  // ==========================================

  const handleViewClick = async (poDetails) => {
    const poId =
      poDetails?._id;

    if (!poId) {
      Swal.fire(
        "Error",
        "Purchase Order ID is missing.",
        "error"
      );

      return;
    }

    if (printLoadingId) {
      return;
    }

    try {
      setPrintLoadingId(
        String(poId)
      );

      // Clear previous print data
      setSelectedItem(null);

      const response =
        await PoServices
          .getPurchaseOrderPrintHistory(
            poId
          );

      console.log(
        "PO PRINT HISTORY RESPONSE:",
        response
      );

      /*
       * Supports both response formats:
       *
       * Axios:
       * response.data.data
       *
       * Custom request helper:
       * response.data
       */
      const printData =
        response?.data?.data ||
        response?.data ||
        null;

      const versions =
        Array.isArray(
          printData?.versions
        )
          ? printData.versions
          : [];

      if (!printData) {
        Swal.fire(
          "Print Data Missing",
          "Purchase Order print data was not found.",
          "warning"
        );

        return;
      }

      if (!versions.length) {
        Swal.fire(
          "No PO Versions",
          "Original or revised Purchase Order versions were not found.",
          "warning"
        );

        return;
      }

      setSelectedItem(
        printData
      );

      setGridInsideModal(
        true
      );

    } catch (error) {
      console.error(
        "Unable to fetch PO print history:",
        error
      );

      Swal.fire(
        "Error",
        error?.response?.data?.message ||
        error?.message ||
        "Unable to load Purchase Order print history.",
        "error"
      );

    } finally {
      setPrintLoadingId("");
    }
  };



  const handleViewItem = (e, row) => {
    e.stopPropagation(); // prevent bubbling if inside clickable row
    setSelectedItem2(row);
    setGridInsideModal2(true);
  };

  const exportToExcel = () => {
    if (filteredSearch.length === 0) {
      Swal.fire("No Data", "No purchase order found to export!", "info");
      return;
    }

    const dataForExcel = filteredSearch.map((row, index) => ({
      "#": index + 1,
      "Requisition": row?.requisitionNo?.requisitionNo || "N/A",
      "PO Number": row?.poNumber || "N/A",
      "Part No": row?.items?.map(i => i.partNo).join(", "),
      "Description": row?.items?.map(i => i.description).join(", "),
      "Qty": row?.items?.map(i => i.approveQty).join(", "),
      "Rate": row?.items?.map(i => i.rate).join(", "),
      "Store": row?.requisitionNo?.store?.name || "N/A",
      "Supplier": row?.items?.map(i => i.supplier?.name).join(", "),
      "Delivery Address": `${row?.deliveryAddress?.street || ""}, ${row?.deliveryAddress?.city || ""}, ${row?.deliveryAddress?.state || ""} - ${row?.deliveryAddress?.pincode || ""}, ${row?.deliveryAddress?.country || ""}`,
      "Created At": new Date(row?.createdAt).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      }),
      "Approved Date": row?.latestApprovedDate
  ? new Date(
      row.latestApprovedDate
    ).toLocaleString(
      "en-GB",
      {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      }
    )
  : "-",
      "Items Count": row?.items?.length || 0
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "PurchaseOrders");
    XLSX.writeFile(workbook, "All_PurchaseOrders.xlsx");

    Swal.fire("Success", "Excel downloaded successfully!", "success");
  };

  const handleRateChangeRequest = (po) => {
    if (!po?._id) {
      Swal.fire(
        "Error",
        "Purchase Order ID is missing.",
        "error"
      );

      return;
    }

    if (
      !Array.isArray(po?.items) ||
      !po.items.length
    ) {
      Swal.fire(
        "No Items",
        "No items found in this Purchase Order.",
        "warning"
      );

      return;
    }

    setSelectedRateChangePO(po);
    setRateChangeModalOpen(true);
  };
  return (
    loading ? (
      <Loader />
    ) : (
      <>
        <Suspense
          fallback={
            rateChangeModalOpen ? (
              <Loader />
            ) : null
          }
        >
          {selectedRateChangePO && (
            <RateChangeRequestModal
              show={rateChangeModalOpen}
              purchaseOrder={
                selectedRateChangePO
              }
              onHide={() => {
                setRateChangeModalOpen(false);
                setSelectedRateChangePO(null);
              }}
              onSuccess={() => {
                setRateChangeModalOpen(false);
                setSelectedRateChangePO(null);
                setTest((prev) => prev + 1);
              }}
            />
          )}
        </Suspense >
        {selectedItem2 && (
          <ReceivedOrderModal
            show={gridInsideModal2}
            handleClose={() => setGridInsideModal2(false)}
            test={setTest}
            admin={selectedItem2}
          />
        )}

        {selectedItem && (
          <PoRevisionPrintModal
            show={gridInsideModal}
            onHide={() => {
              setGridInsideModal(false);
              setSelectedItem(null);
            }}
            printHistory={selectedItem}
          />
        )}
        <div className="row">
          <div className="col-xl-12">

            {/* Filter */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa"><i className="fas fa-filter me-2"></i>Filter</div>
                <div className="tools">
                  <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6 mb-3">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Part No. , Requisition No., Po Number, Supplier Name, Store"
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setActivePage(0);
                          }}
                        />
                      </div>
                      <div className="col-xl-3 col-xxl-6 mb-3">
                        <Select
                          placeholder="Rows per page"
                          value={options.find(option => option.value === sort)}
                          onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Table */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fa fa-list me-2"></i>All Purchase Orders
                  <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
                </div>

                <div className="d-flex align-items-center gap-2">


                  <button
                    className="btn btn-success btn-sm"
                    onClick={exportToExcel}
                  >
                    <i className="fa fa-file-excel me-1"></i>
                    Download Excel
                  </button>

                  <div className="tools">
                    <Link
                      to="#"
                      className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                      onClick={() => setOpen2(!open2)}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Link>
                  </div>
                </div>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div id="content_wrapper" className="dataTables_wrapper no-footer">
                        <div className="scrolltable">
                          <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                            <thead
                              className="sticky-table-header"
                            >
                              <tr>
                                <th>#</th>
                                <th>Requisition</th>
                                <th>Po</th>
                                <th>Part No</th>
                                <th>Description</th>
                                <th>Qty</th>
                                <th>Rate</th>
                                <th>Store</th>
                                <th>Suppplier</th>
                                <th>Deliver Address</th>
                                <th
                                  onClick={() => handleSort("createdAt")}
                                  style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                                >
                                  Created At{" "}
                                  {sortField === "createdAt" ? (sortOrder === "asc" ? "🔼" : "🔽") : "⇅"}
                                </th>

                                <th
                                  onClick={() => handleSort("approvedDate")}
                                  style={{ cursor: "pointer", whiteSpace: "nowrap" }}
                                >
                                  Approved Date{" "}
                                  {sortField === "approvedDate" ? (sortOrder === "asc" ? "🔼" : "🔽") : "⇅"}
                                </th>

                                <th>Items</th>
                                <th>View Items</th>
                                <th>Print</th>
                                {userRole === "pomaker" && (
                                  <th>Rate Change Request</th>
                                )}

                              </tr>
                            </thead>
                            <tbody>
                              {filteredSearch.length > 0 ? (
                                filteredSearch
                                  .slice(activePage * sort, (activePage + 1) * sort)
                                  .map((row, index) => (
                                    <tr key={index}>
                                      <td>{activePage * sort + index + 1}</td>
                                      <td>{row?.requisitionNo?.requisitionNo || row?.requisitionNo?._id || 'N/A'}</td>
                                      <td>{row?.poNumber || 'N/A'}</td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.partNo || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td className="scrollable-description">
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.description || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.approveQty || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td>
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.rate || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td className="scrollable-description">{row?.requisitionNo?.store?.name}</td>
                                      <td className="scrollable-description">
                                        {row?.items?.map((item, idx) => (
                                          <div key={idx}>{item?.supplier?.name || 'N/A'}</div>
                                        ))}
                                      </td>
                                      <td className="scrollable-description">
                                        {row?.deliveryAddress?.street}, {row?.deliveryAddress?.city},<br />
                                        {row?.deliveryAddress?.state} - {row?.deliveryAddress?.pincode},<br />
                                        {row?.deliveryAddress?.country}
                                      </td>
                                      <td>
                                        {new Date(row?.createdAt).toLocaleString("en-GB", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          second: "2-digit",
                                          hour12: false
                                        })}
                                      </td>

                                      <td>
                                        {row?.latestApprovedDate
                                          ? new Date(
                                            row.latestApprovedDate
                                          ).toLocaleString(
                                            "en-GB",
                                            {
                                              day: "2-digit",
                                              month: "2-digit",
                                              year: "numeric",
                                              hour: "2-digit",
                                              minute: "2-digit",
                                              second: "2-digit",
                                              hour12: false
                                            }
                                          )
                                          : "-"
                                        }
                                      </td>

                                      <td>{row?.items?.length || 0}</td>
                                      <td className="align-middle">
                                        <div className="d-flex justify-content-center align-items-center">
                                          <i
                                            className="fa fa-eye"
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => handleViewItem(e, row)}
                                          ></i>
                                        </div>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-success btn-xs"
                                          disabled={
                                            Boolean(printLoadingId)
                                          }
                                          onClick={() =>
                                            handleViewClick(row)
                                          }
                                        >
                                          {String(printLoadingId) ===
                                            String(row?._id) ? (
                                            <>
                                              <span
                                                className="spinner-border spinner-border-sm me-1"
                                                role="status"
                                                aria-hidden="true"
                                              />

                                              Loading...
                                            </>
                                          ) : (
                                            <>
                                              <i className="fa fa-print me-1" />

                                              Print

                                              <span
                                                className="badge bg-light text-dark ms-2"
                                                style={{
                                                  minWidth: "24px",
                                                  fontSize: "11px"
                                                }}
                                              >
                                                {row?.printCount || 1}
                                              </span>
                                            </>
                                          )}
                                        </button>
                                      </td>
                                      {userRole === "pomaker" && (
                                        <td className="text-center">
                                          <button
                                            type="button"
                                            className="btn btn-warning btn-xs"
                                            onMouseEnter={preloadRateChangeModal}
                                            onFocus={preloadRateChangeModal}
                                            onClick={() => handleRateChangeRequest(row)}
                                          >
                                            Request
                                          </button>
                                        </td>
                                      )}

                                    </tr>
                                  ))
                              ) : (
                                <tr><td colSpan="13" className="text-center">No Purchase Orders Found</td></tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {/* Pagination */}
                        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                          <div className="dataTables_info">
                            Showing{" "}
                            {filteredSearch.length > 0
                              ? activePage * sort + 1
                              : 0}{" "}
                            to{" "}
                            {Math.min(
                              filteredSearch.length,
                              (activePage + 1) * sort
                            )}{" "}
                            of {filteredSearch.length} entries
                          </div>

                          <Pagination
                            activePage={activePage}
                            totalPages={pagination}
                            onPageChange={onClick}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default POPrint;
